import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import { GAME_DB } from '../../../db/game';
import { GAME_END_TIME, GAME_START_TIME, GAME_TIME_LEFT } from '../../../app.config.vars/stored';
import { getAtomFormattedDate } from '../../../helpers';
import { sendCompleteGame } from '../../../api/game-mode/game';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { setGameStatus } from '../../../store/slices/rallyGame';
const FinishUncompletedGame = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    return (_jsxs("div", { className: 'modal-content save-uncompleted-game', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('finish_uncompleted_game'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { variant: 'outlined', label: t('button.abbort_and_end'), onClick: async () => {
                                const gameEndTime = getAtomFormattedDate(Date.now());
                                localStorage.setItem(GAME_END_TIME, gameEndTime);
                                dispatch(setGameStatus('ended'));
                                const gameCompleted = await sendCompleteGame({
                                    isTimedOut: false,
                                    endTime: gameEndTime,
                                });
                                if (!gameCompleted.error) {
                                    localStorage.removeItem(GAME_START_TIME);
                                    localStorage.removeItem(GAME_END_TIME);
                                    localStorage.removeItem(GAME_TIME_LEFT);
                                    await GAME_DB.RESET.game();
                                    dispatch(setModalContent(MODAL_CONTENT.gameResultSuccessfullySaved.key));
                                }
                                else {
                                    dispatch(setModalContent(MODAL_CONTENT.noInternetToSaveGameResult.key));
                                }
                            } }), _jsx(Button, { label: t('button.no'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            } })] }) })] }));
};
export default FinishUncompletedGame;
